import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default (els) => {
	Array.prototype.forEach.call(els, (el) => {
		//console.log(el);

		const logo = el.querySelector('.newsletter__logo');
		const content = el.querySelector('.newsletter__content');

		let timeline = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 80%',
				end: 'top 40%',
				scrub: 1,
				markers: false,
			},
		});

		timeline.from(logo, {
			autoAlpha: 0,
			duration: 1,
			y: '-=50',
		});

		timeline.from(content, {
			autoAlpha: 0,
			duration: 1,
			y: '+=50',
		});
	});
};
